import React, {useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {Redirect, Switch} from 'react-router-dom'
import TransactionRedux from '../transaction/redux/TransactionRedux'
import AuthRedux from './redux/AuthRedux'

export function Logout() {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(AuthRedux.actions.logout())
    dispatch(TransactionRedux.actions.setCountTransaction(0, 0, 0))
    // document.location.reload()
  }, [dispatch])

  return (
    <Switch>
      <Redirect to='/auth/login-email' />
    </Switch>
  )
}
